<onyx-section [heading]="`${I18N}.heading`">
  @let controls = form().controls;
  <form [formGroup]="form()">
    @let mainTankControl = controls.mainTank;
    @let fuelTypeControl = controls.fuelType;

    @if (mainTankControl.enabled && fuelTypeControl.enabled) {
      <onyx-form-group
        label="labels.mainTank"
        [controls]="[mainTankControl!, fuelTypeControl!]"
        (labelClick)="mainTankControlElement.focus()"
      >
        <onyx-text-field
          data-testid="main-tank-capacity-field"
          [formControl]="mainTankControl"
          [decimalPlaces]="2"
          [unit]="fuelType()?.units?.[0]"
          [showErrors]="false"
          #mainTankControlElement
          [size]="32"
        ></onyx-text-field>

        <onyx-dropdown
          data-testid="fuel-type-dropdown"
          [formControl]="fuelTypeControl"
          [options]="fuelTypes()"
          width="max-content"
          [showErrors]="false"
          [size]="32"
        ></onyx-dropdown>
      </onyx-form-group>
    }

    @if (controls.additionalTank.enabled) {
      <onyx-text-field
        data-testid="additional-tank-capacity-field"
        [formControl]="controls.additionalTank"
        label="labels.additionalTank"
        [decimalPlaces]="2"
        [unit]="fuelType()?.units?.[1]"
        [size]="32"
      ></onyx-text-field>
    }

    @if (controls.adBlueTank.enabled) {
      <onyx-text-field
        data-testid="adblue-tank-capacity-field"
        [formControl]="controls.adBlueTank"
        label="labels.adBlue"
        [decimalPlaces]="2"
        unit="L"
        [size]="32"
      ></onyx-text-field>
    }

    @if (controls.generatorFuelTank.enabled) {
      <onyx-text-field
        data-testid="generator-fuel-tank-capacity-field"
        [formControl]="controls.generatorFuelTank"
        label="labels.generatorFuelTank"
        [decimalPlaces]="2"
        unit="L"
        [size]="32"
      ></onyx-text-field>
    }
  </form>
</onyx-section>
